import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSaleSoModel } from "../saleSoModel";
import { ISaleSoDetail } from "../saleSoTypes";
import { useDictModel } from "../../../../base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";



type statusType = {
    "sale.create": string,
    "sale.stock-io": string,
    "sale.settle": string,
    "sale.change": string,
    [key: string]: any
}
export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg,descRows, loadData, setSelectedRowKeys,setDescRows } = useSaleSoModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const statusColor: statusType = {
        "sale.create": "blue",
        "sale.stock-io": "cyan",
        "sale.settle": "green",
        "sale.change": "red",
    }

    const columns: ColumnsType<ISaleSoDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            // title: '销售单号',
            title: Locale["Sales Doc No."],
            width: 120,
            fixed: "left",
            dataIndex: 'saleCode',
        }, {
            // title: '单据状态',
            title: Locale["Status"],
            width: 120,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            // title: '支付状态',
            title: Locale["Payment status"],
            width: 160,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)
        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            width: 150,
            dataIndex: 'createTime',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 150,
            dataIndex: 'customerName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            width: 150,
            dataIndex: 'contact',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 150,
            dataIndex: 'phone',
        }, {
            // title: '销售金额',
            title: Locale["Sales Amount"],
            width: 150,
            dataIndex: 'totalAmount',
        }, {
            // title: '优惠金额',
            title: Locale["Discount Amount"],
            width: 150,
            dataIndex: 'discountTotalAmount',

        }, {
            // title: '已收金额',
            title: Locale["Received Amount"],
            width: 150,
            dataIndex: 'amountReceived',
            // render: (text) => (Number(text) * 1.15).toFixed(2)

        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 150,
            dataIndex: 'createUser',
        }, {
            // title: '库管员',
            title: Locale["Storekeeper"],
            width: 150,
            dataIndex: 'storekeeper',
        }, {
            // title: '出库日期',
            title: Locale["Stock-out Time"],
            width: 150,
            ellipsis: true,
            dataIndex: 'stockIoTime',
        }, {
            // title: '结算员',
            title: Locale["Reckoner"],
            width: 150,
            dataIndex: 'reckoner',
        }, {
            // title: '结算日期',
            title: Locale["Settle Time"],
            width: 150,
            ellipsis: true,
            dataIndex: 'settleTime',
        }, {
            // title: '核销时间',
            title: Locale["Write off time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'payTime',
        }, {
            // title: '打印次数',
            title: Locale["Print Times"],
            width: 150,
            dataIndex: 'printingTimes',
        }, {
            // title: '销售订单号',
            title: Locale["Sales Order No."],
            width: 120,
            dataIndex: 'saleOrderCode',
        },{
            // title: '备注',
            title: Locale["Note"],
            width: 150,
            dataIndex: 'note',
        }, {
            // title: '结算类型',
            title: Locale["Payment Type"],
            width: 120,
            dataIndex: 'payType',
            fixed:"right",
            // render: (text) => `${getTreeNodeName(text)}`,
            render: (text) => {
                if (text && !!getTreeNodeOne(text)) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                }else{
                    return ""
                }
            }
        }, {
            // title: '应收金额',
            title: Locale["Receivable Amount"],
            width: 150,
            dataIndex: 'receivedAmount',
            fixed:"right"
            // render: (text) => (Number(text) * 1.15).toFixed(2)
        }
    ];
    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (record: ISaleSoDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: ISaleSoDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 550 }}
        />
    )
}
